import React, { Component } from 'react';
import GDRowActions from 'Components/GDTable/GDRowActions';
export class AgGridButton extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
        this.state = {
            isClicked: false,
        }
    }

    render() {
        if (this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props) {
            let rowLength = this.props.context.componentParent.props.rowData !== undefined && this.props.context.componentParent.props.rowData.length > 0 ? this.props.context.componentParent.props.rowData.length : this.props.context.componentParent.props.totalRecords;
            return (
                <span>
                    <span > <GDRowActions
                        isGridCompact={this.props.isGridCompact}
                        isOpen={this.state.isClicked}
                        openBoxDropDownStyle={this.props.context.componentParent.props.openBoxDropDownStyle}
                        rowActionClick={this.invokeParentMethod}
                        rowId={this.props.node.rowIndex}
                        triggerText={this.props.context.componentParent.props.triggerText}
                        isCaseSelection={true}
                        actions={this.props.context.componentParent.props.actions}
                        caseStageId={this.props.data ? this.props.data.caseStageId : undefined}
                        isMerchatActions={this.props.context.componentParent.props.isMerchatActions}
                        getMerchantActions={this.props.context.componentParent.props.getMerchantActions}
                        rowIndex={this.props.node.rowIndex}
                        rowLength={rowLength}
                        onCloseClick={this.props.context.componentParent.props.onCloseClick}
                        isArchival={this.props.context.componentParent.props.isArchival ? this.props.context.componentParent.props.isArchival : false}
                    /></span>
                </span>
            );
        }
    }

    invokeParentMethod(rowIndex, key) {
        this.setState({
            isClicked: false,
        })
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.rowActionClick &&  this.props.context.componentParent.props.rowActionClick(this.props.node.rowIndex, key);
    };
}
export default AgGridButton;
